/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Free_LabelInputs */

const en_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free (EUR 0/month): `)
};

const de_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free (EUR 0/Monat): `)
};

const fr_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit (EUR 0/mois) : `)
};

const es_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis (EUR 0/mes): `)
};

const it_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis (EUR 0/mese): `)
};

const nl_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis (EUR 0/maand): `)
};

const pl_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmo (EUR 0/mies.): `)
};

const fi_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen (EUR 0/kk): `)
};

const da_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis (EUR 0/måned): `)
};

const sv_agb_tier_free_label = /** @type {(inputs: Agb_Tier_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis (EUR 0/månad): `)
};

/**
* | output |
* | --- |
* | "Free (EUR 0/month):" |
*
* @param {Agb_Tier_Free_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_free_label = /** @type {((inputs?: Agb_Tier_Free_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Free_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_free_label(inputs)
	if (locale === "fr") return fr_agb_tier_free_label(inputs)
	if (locale === "es") return es_agb_tier_free_label(inputs)
	if (locale === "it") return it_agb_tier_free_label(inputs)
	if (locale === "nl") return nl_agb_tier_free_label(inputs)
	if (locale === "pl") return pl_agb_tier_free_label(inputs)
	if (locale === "fi") return fi_agb_tier_free_label(inputs)
	if (locale === "da") return da_agb_tier_free_label(inputs)
	if (locale === "sv") return sv_agb_tier_free_label(inputs)
	return en_agb_tier_free_label(inputs)
});